/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActionFlowSubscriptionDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Update dynamic form configuration
 */
export const setDynamicFormConfig = (
    domain: string,
    subscriptionId: string,
    setDynamicFormConfigBody: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDynamicFormConfigBody
    },
      options);
    }
  


export const getSetDynamicFormConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDynamicFormConfig>>, TError,{domain: string;subscriptionId: string;data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDynamicFormConfig>>, TError,{domain: string;subscriptionId: string;data: string}, TContext> => {

const mutationKey = ['setDynamicFormConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDynamicFormConfig>>, {domain: string;subscriptionId: string;data: string}> = (props) => {
          const {domain,subscriptionId,data} = props ?? {};

          return  setDynamicFormConfig(domain,subscriptionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDynamicFormConfigMutationResult = NonNullable<Awaited<ReturnType<typeof setDynamicFormConfig>>>
    export type SetDynamicFormConfigMutationBody = string
    export type SetDynamicFormConfigMutationError = unknown

    /**
 * @summary Update dynamic form configuration
 */
export const useSetDynamicFormConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDynamicFormConfig>>, TError,{domain: string;subscriptionId: string;data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDynamicFormConfig>>,
        TError,
        {domain: string;subscriptionId: string;data: string},
        TContext
      > => {

      const mutationOptions = getSetDynamicFormConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Assign flow to a subscription
 */
export const assignFlow = (
    domain: string,
    subscriptionId: string,
    flowId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ActionFlowSubscriptionDTO>(
      {url: `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/flow/${flowId}`, method: 'PUT'
    },
      options);
    }
  


export const getAssignFlowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFlow>>, TError,{domain: string;subscriptionId: string;flowId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignFlow>>, TError,{domain: string;subscriptionId: string;flowId: string}, TContext> => {

const mutationKey = ['assignFlow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignFlow>>, {domain: string;subscriptionId: string;flowId: string}> = (props) => {
          const {domain,subscriptionId,flowId} = props ?? {};

          return  assignFlow(domain,subscriptionId,flowId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignFlowMutationResult = NonNullable<Awaited<ReturnType<typeof assignFlow>>>
    
    export type AssignFlowMutationError = unknown

    /**
 * @summary Assign flow to a subscription
 */
export const useAssignFlow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFlow>>, TError,{domain: string;subscriptionId: string;flowId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignFlow>>,
        TError,
        {domain: string;subscriptionId: string;flowId: string},
        TContext
      > => {

      const mutationOptions = getAssignFlowMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all subscriptions
 */
export const getAllSubscriptions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowSubscriptionDTO[]>(
      {url: `/api/v1/action-flows/subscriptions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllSubscriptionsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/action-flows/subscriptions`
    ] as const;
    }

export const getGetAllSubscriptionsQueryKey = () => {
    return [
    `/api/v1/action-flows/subscriptions`
    ] as const;
    }

    
export const getGetAllSubscriptionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllSubscriptions>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSubscriptionsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSubscriptions>>> = ({ signal }) => getAllSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllSubscriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSubscriptions>>>
export type GetAllSubscriptionsInfiniteQueryError = unknown


export function useGetAllSubscriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllSubscriptions>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAllSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubscriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllSubscriptions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAllSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubscriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllSubscriptions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all subscriptions
 */

export function useGetAllSubscriptionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllSubscriptions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllSubscriptionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAllSubscriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSubscriptions>>> = ({ signal }) => getAllSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSubscriptions>>>
export type GetAllSubscriptionsQueryError = unknown


export function useGetAllSubscriptions<TData = Awaited<ReturnType<typeof getAllSubscriptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAllSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubscriptions<TData = Awaited<ReturnType<typeof getAllSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAllSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubscriptions<TData = Awaited<ReturnType<typeof getAllSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all subscriptions
 */

export function useGetAllSubscriptions<TData = Awaited<ReturnType<typeof getAllSubscriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get dynamic form configuration based on primary group
 */
export const getDynamicRuntimeFormConfig = (
    domain: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDynamicRuntimeFormConfigInfiniteQueryKey = (domain?: string,
    subscriptionId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime`
    ] as const;
    }

export const getGetDynamicRuntimeFormConfigQueryKey = (domain?: string,
    subscriptionId?: string,) => {
    return [
    `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime`
    ] as const;
    }

    
export const getGetDynamicRuntimeFormConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>, TError = unknown>(domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicRuntimeFormConfigInfiniteQueryKey(domain,subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>> = ({ signal }) => getDynamicRuntimeFormConfig(domain,subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicRuntimeFormConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>
export type GetDynamicRuntimeFormConfigInfiniteQueryError = unknown


export function useGetDynamicRuntimeFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration based on primary group
 */

export function useGetDynamicRuntimeFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicRuntimeFormConfigInfiniteQueryOptions(domain,subscriptionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDynamicRuntimeFormConfigQueryOptions = <TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError = unknown>(domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicRuntimeFormConfigQueryKey(domain,subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>> = ({ signal }) => getDynamicRuntimeFormConfig(domain,subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicRuntimeFormConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>>
export type GetDynamicRuntimeFormConfigQueryError = unknown


export function useGetDynamicRuntimeFormConfig<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfig<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfig<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration based on primary group
 */

export function useGetDynamicRuntimeFormConfig<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicRuntimeFormConfigQueryOptions(domain,subscriptionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get dynamic form configuration based on workflow node ID
 */
export const getDynamicRuntimeFormConfigByNodeId = (
    domain: string,
    subscriptionId: string,
    nodeId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime/node/${nodeId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDynamicRuntimeFormConfigByNodeIdInfiniteQueryKey = (domain?: string,
    subscriptionId?: string,
    nodeId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime/node/${nodeId}`
    ] as const;
    }

export const getGetDynamicRuntimeFormConfigByNodeIdQueryKey = (domain?: string,
    subscriptionId?: string,
    nodeId?: string,) => {
    return [
    `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-runtime/node/${nodeId}`
    ] as const;
    }

    
export const getGetDynamicRuntimeFormConfigByNodeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>, TError = unknown>(domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicRuntimeFormConfigByNodeIdInfiniteQueryKey(domain,subscriptionId,nodeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>> = ({ signal }) => getDynamicRuntimeFormConfigByNodeId(domain,subscriptionId,nodeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId && nodeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicRuntimeFormConfigByNodeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>
export type GetDynamicRuntimeFormConfigByNodeIdInfiniteQueryError = unknown


export function useGetDynamicRuntimeFormConfigByNodeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigByNodeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigByNodeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration based on workflow node ID
 */

export function useGetDynamicRuntimeFormConfigByNodeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicRuntimeFormConfigByNodeIdInfiniteQueryOptions(domain,subscriptionId,nodeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDynamicRuntimeFormConfigByNodeIdQueryOptions = <TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError = unknown>(domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicRuntimeFormConfigByNodeIdQueryKey(domain,subscriptionId,nodeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>> = ({ signal }) => getDynamicRuntimeFormConfigByNodeId(domain,subscriptionId,nodeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId && nodeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicRuntimeFormConfigByNodeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>>
export type GetDynamicRuntimeFormConfigByNodeIdQueryError = unknown


export function useGetDynamicRuntimeFormConfigByNodeId<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigByNodeId<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>,
          TError,
          Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicRuntimeFormConfigByNodeId<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration based on workflow node ID
 */

export function useGetDynamicRuntimeFormConfigByNodeId<TData = Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError = unknown>(
 domain: string,
    subscriptionId: string,
    nodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicRuntimeFormConfigByNodeId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicRuntimeFormConfigByNodeIdQueryOptions(domain,subscriptionId,nodeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get dynamic form configuration
 */
export const getDynamicEditFormConfig = (
    domain: string,
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-edit`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDynamicEditFormConfigInfiniteQueryKey = (domain?: string,
    subscriptionId?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-edit`
    ] as const;
    }

export const getGetDynamicEditFormConfigQueryKey = (domain?: string,
    subscriptionId?: string,) => {
    return [
    `/api/v1/action-flows/subscriptions/${domain}/${subscriptionId}/form-config-edit`
    ] as const;
    }

    
export const getGetDynamicEditFormConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>, TError = unknown>(domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicEditFormConfigInfiniteQueryKey(domain,subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicEditFormConfig>>> = ({ signal }) => getDynamicEditFormConfig(domain,subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicEditFormConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>
export type GetDynamicEditFormConfigInfiniteQueryError = unknown


export function useGetDynamicEditFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicEditFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicEditFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration
 */

export function useGetDynamicEditFormConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicEditFormConfigInfiniteQueryOptions(domain,subscriptionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDynamicEditFormConfigQueryOptions = <TData = Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError = unknown>(domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDynamicEditFormConfigQueryKey(domain,subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicEditFormConfig>>> = ({ signal }) => getDynamicEditFormConfig(domain,subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain && subscriptionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDynamicEditFormConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getDynamicEditFormConfig>>>
export type GetDynamicEditFormConfigQueryError = unknown


export function useGetDynamicEditFormConfig<TData = Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicEditFormConfig<TData = Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>,
          TError,
          Awaited<ReturnType<typeof getDynamicEditFormConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDynamicEditFormConfig<TData = Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get dynamic form configuration
 */

export function useGetDynamicEditFormConfig<TData = Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError = unknown>(
 domain: string,
    subscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDynamicEditFormConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDynamicEditFormConfigQueryOptions(domain,subscriptionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get subscriptions by domain
 */
export const getSubscriptionsByDomain = (
    domain: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActionFlowSubscriptionDTO[]>(
      {url: `/api/v1/action-flows/subscriptions/domain/${domain}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSubscriptionsByDomainInfiniteQueryKey = (domain?: string,) => {
    return [
    'infinite', `/api/v1/action-flows/subscriptions/domain/${domain}`
    ] as const;
    }

export const getGetSubscriptionsByDomainQueryKey = (domain?: string,) => {
    return [
    `/api/v1/action-flows/subscriptions/domain/${domain}`
    ] as const;
    }

    
export const getGetSubscriptionsByDomainInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>, TError = unknown>(domain: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsByDomainInfiniteQueryKey(domain);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsByDomain>>> = ({ signal }) => getSubscriptionsByDomain(domain, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubscriptionsByDomainInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>
export type GetSubscriptionsByDomainInfiniteQueryError = unknown


export function useGetSubscriptionsByDomainInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>, TError = unknown>(
 domain: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsByDomainInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsByDomainInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get subscriptions by domain
 */

export function useGetSubscriptionsByDomainInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubscriptionsByDomainInfiniteQueryOptions(domain,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSubscriptionsByDomainQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError = unknown>(domain: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsByDomainQueryKey(domain);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsByDomain>>> = ({ signal }) => getSubscriptionsByDomain(domain, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(domain), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubscriptionsByDomainQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsByDomain>>>
export type GetSubscriptionsByDomainQueryError = unknown


export function useGetSubscriptionsByDomain<TData = Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError = unknown>(
 domain: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsByDomain<TData = Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsByDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsByDomain<TData = Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get subscriptions by domain
 */

export function useGetSubscriptionsByDomain<TData = Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError = unknown>(
 domain: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsByDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubscriptionsByDomainQueryOptions(domain,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




